import { useRouteContext } from '@tanstack/react-router';

/**
 * Hook to get the current organization ID from the route context.
 * The organizationId is extracted from the JWT token and stored in the route context,
 * so this avoids unnecessary API calls to fetch all organizations.
 */
export const useOrgId = (): string => {
  const routeContext = useRouteContext({ strict: false });

  return routeContext.organizationId ?? '';
};
